import Item from "./item";
export default class Filtros{
    public uf : Item | null = null;
    public municipios : Array<Item> = new Array<Item>();
    public situacoesLote: Array<Item> = new Array<Item>();
    public situacoesLicitacao: Array<Item> = new Array<Item>();
    public situacoesContrato: Array<Item> = new Array<Item>();
    public departamentos: Array<Item> = new Array<Item>();
    public numeroProcesso: string = '';
    public descricao: string = '';
    public codLote: number | null = null;
    public codContrato: number | null = null;
    public endereco: string = '';
    public dataInicialAssinaturaContrato: string = '';
    public dataFinalAssinaturaContrato: string = '';
    public geoLocalizados: boolean = true;
    public ativos: boolean = true;
    public usuarioId: number = 0;
    public classificacaoProjeto: number | null = null;
    public listaTipoObjeto: Array<number> = new Array<number>();
}
